module.exports = __webpack_public_path__ + "img/970204845_1200.69b47d3f.jpg";